export default {
  downtimeUrl: "https://pl3.kodland.tech",
  startPage: {
    image: "/welcome/quiz_student_with_parent.jpeg",
    title: "Odpowiedz na 5 pytań i otrzymaj DARMOWĄ lekcje dla swojego dziecka",
    subtitle: "Twoje dziecko stworzy swój pierwszy projekt: grę albo program",
    button: "Zaczynajmy",
  },
  successPage: {
    title: "Wybierz datę i godzinę, aby otrzymać lekcję ZA DARMO",
    subtitle: "Kliknij przycisk “📆 Zarezerwować lekcję“, aby dokończyć rejestrację",
    button: "📆 Zarezerwować lekcję",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title: "Dziękujemy za zaufanie do naszej platformy edukacyjnej! Niestety, tablety czy telefony nie nadają się na lekcje. Czekamy na Państwo na zajęciach następnym razem!",
  },
  quizRotateBySteps: {
    1: {
      question: "Jak Twoje dziecko najczęściej spędza czas wolny?",
      answers: [
        "🎨 Na zajęciach artystycznych: rysowanie, muzyka, aktorstwo", 
        "🎮 Gra w gry na telefonie lub na komputerze",  
        "📈 Przygotować dziecko do kariery programisty", 
        "😊 Gra w gry planszowe",
        "🏃‍♂️ Uprawia sport",
        "👨‍👩‍👦 Spędza czas z rodziną",
        "🦀 Ogląda kreskówki",
        "💬 Spędza czas z przyjaciółmi"  
      ],
    },
    2: {
      question: "Jaki jest ulubiony przedmiot Twojego dziecka w szkole?",
      answers: [
        "🔬 Nauki ścisłe",
        "🎨 Sztuka i projektowanie",
        "🖥 Informatyka",
        "📐 Matematyka",
        "📙 Historia, literatura",
        "💬 Języki obce",
        "💙 Lubi wszystkie przedmioty",
        "🫠 Nie jestem pewien/pewna"
      ],
    },
    3: {
      question: "Czy Twoje dziecko posiada jakieś umiejętności komputerowe?",
      answers: [
        "👍 Tak, lubi grać w gry komputerowe (roblox, minecraft)", 
        "👏 Tak, word/power point",
        "🤝 Tak, podstawowe umiejętności",   
        "🤔 Nie",
      ],
    },
    4: {
      question: "Czy masz komputer/laptop służący do nauki?",
      answers: [
        "👍 Tak",
        {
          answer: "😕 Nie",
          stopAnswer: true
        },
      ],
    },
  },
};


